var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _polygon, _path34;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.83,86.19c-74.56,35.45-8.31,95.44-51.57,129.38s-158.87-2.65-115.92,83C132.8,399.18,360.89,381.45,412,256.23S324.38,50.74,249.83,86.19Z",
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83,86.19c-74.56,35.45-8.31,95.44-51.57,129.38s-158.87-2.65-115.92,83C132.8,399.18,360.89,381.45,412,256.23S324.38,50.74,249.83,86.19Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-15"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-15",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--program-icons--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 293.83,
    y: 93.01,
    width: 34.37,
    height: 34.37,
    rx: 2.27,
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 293.83,
    y: 93.01,
    width: 34.37,
    height: 34.37,
    rx: 2.27,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.4,108.38l-6,2.19,6,2.17V115l-8.52-3.25v-2.32l8.52-3.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.82,101.76h2.49l-5.92,16.87H306.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.15,109.41v2.32L315.63,115v-2.24l6-2.17-6-2.19v-2.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.4,133.66V142h-1.93v-3.43h-3.8V142h-1.93v-8.35h1.93V137h3.8v-3.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.12,135.23h-2.68v-1.57h7.28v1.57h-2.67V142h-1.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.37,142v-5l-2.46,4.13H315l-2.45-4V142h-1.81v-8.35h1.6l3.12,5.19,3.08-5.19h1.59l0,8.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.17,133.66h1.93v6.77h4.19V142h-6.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.4,133.66V142h-1.93v-3.43h-3.8V142h-1.93v-8.35h1.93V137h3.8v-3.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.12,135.23h-2.68v-1.57h7.28v1.57h-2.67V142h-1.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.37,142v-5l-2.46,4.13H315l-2.45-4V142h-1.81v-8.35h1.6l3.12,5.19,3.08-5.19h1.59l0,8.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.17,133.66h1.93v6.77h4.19V142h-6.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 367.34,
    y: 111.33,
    width: 34.37,
    height: 34.37,
    rx: 2.27,
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.34,
    y: 111.33,
    width: 34.37,
    height: 34.37,
    rx: 2.27,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M378.89,128.51c.82.25,1.2.77,1.2,2v2.87a1.18,1.18,0,0,0,1.31,1.32h.32v2.19h-1c-2.24,0-3.38-1.15-3.38-3.21v-3.24a.74.74,0,0,0-.79-.84h-.59v-2.19h.59a.74.74,0,0,0,.79-.84v-3.24c0-2.06,1.14-3.21,3.38-3.21h1v2.19h-.32a1.18,1.18,0,0,0-1.31,1.32v2.87C380.09,127.74,379.71,128.26,378.89,128.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.13,127.42v2.19h-.59a.74.74,0,0,0-.79.84v3.24c0,2.06-1.15,3.21-3.38,3.21h-1v-2.19h.32a1.18,1.18,0,0,0,1.31-1.32v-2.87c0-1.24.37-1.76,1.2-2-.83-.25-1.2-.77-1.2-2v-2.87a1.18,1.18,0,0,0-1.31-1.32h-.32v-2.19h1c2.23,0,3.38,1.15,3.38,3.21v3.24a.74.74,0,0,0,.79.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,156.28a4.6,4.6,0,0,1,8-2.84l-1.24,1.15a2.68,2.68,0,0,0-2.1-1,2.68,2.68,0,1,0,0,5.35,2.69,2.69,0,0,0,2.1-1l1.24,1.14a4.59,4.59,0,0,1-8-2.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.52,159.64l.65-1.46a5,5,0,0,0,2.76.87c1.14,0,1.61-.38,1.61-.89,0-1.57-4.86-.49-4.86-3.59,0-1.42,1.15-2.61,3.52-2.61a5.68,5.68,0,0,1,2.9.74l-.59,1.47a4.75,4.75,0,0,0-2.32-.65c-1.14,0-1.59.42-1.59.95,0,1.54,4.86.48,4.86,3.54,0,1.4-1.16,2.59-3.54,2.59A6,6,0,0,1,381.52,159.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.13,159.64l.66-1.46a4.92,4.92,0,0,0,2.76.87c1.14,0,1.61-.38,1.61-.89,0-1.57-4.86-.49-4.86-3.59,0-1.42,1.15-2.61,3.52-2.61a5.71,5.71,0,0,1,2.9.74l-.6,1.47a4.69,4.69,0,0,0-2.31-.65c-1.15,0-1.59.42-1.59.95,0,1.54,4.86.48,4.86,3.54,0,1.4-1.16,2.59-3.55,2.59A6,6,0,0,1,389.13,159.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373,156.28a4.6,4.6,0,0,1,8-2.84l-1.24,1.15a2.68,2.68,0,0,0-2.1-1,2.68,2.68,0,1,0,0,5.35,2.69,2.69,0,0,0,2.1-1l1.24,1.14a4.59,4.59,0,0,1-8-2.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.52,159.64l.65-1.46a5,5,0,0,0,2.76.87c1.14,0,1.61-.38,1.61-.89,0-1.57-4.86-.49-4.86-3.59,0-1.42,1.15-2.61,3.52-2.61a5.68,5.68,0,0,1,2.9.74l-.59,1.47a4.75,4.75,0,0,0-2.32-.65c-1.14,0-1.59.42-1.59.95,0,1.54,4.86.48,4.86,3.54,0,1.4-1.16,2.59-3.54,2.59A6,6,0,0,1,381.52,159.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.13,159.64l.66-1.46a4.92,4.92,0,0,0,2.76.87c1.14,0,1.61-.38,1.61-.89,0-1.57-4.86-.49-4.86-3.59,0-1.42,1.15-2.61,3.52-2.61a5.71,5.71,0,0,1,2.9.74l-.6,1.47a4.69,4.69,0,0,0-2.31-.65c-1.15,0-1.59.42-1.59.95,0,1.54,4.86.48,4.86,3.54,0,1.4-1.16,2.59-3.55,2.59A6,6,0,0,1,389.13,159.64Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tabs--inject-15"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 148.55,
    y: 107.98,
    width: 122.51,
    height: 88.68
  })), /*#__PURE__*/React.createElement("rect", {
    x: 148.55,
    y: 107.98,
    width: 122.51,
    height: 88.68,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.55,
    y: 107.98,
    width: 17.06,
    height: 88.68,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.55,
    y: 107.98,
    width: 122.51,
    height: 8.29,
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.71,128.78H175.4a1,1,0,0,1,0-2h22.31a1,1,0,0,1,0,2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M247,128.78H203.65a1,1,0,0,1,0-2H247a1,1,0,0,1,0,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M236.68,135.31H178.4a1,1,0,0,1,0-2h58.28a1,1,0,0,1,0,2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.94,141.83H175.4a1,1,0,0,1,0-2h37.54a1,1,0,0,1,0,2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M247,141.83h-26.9a1,1,0,0,1,0-2H247a1,1,0,0,1,0,2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.13,148.36H175.4a1,1,0,1,1,0-2h20.73a1,1,0,0,1,0,2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M235.49,148.36H202.85a1,1,0,0,1,0-2h32.64a1,1,0,0,1,0,2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.29,154.89H178.4a1,1,0,1,1,0-2h27.89a1,1,0,0,1,0,2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.78,161.42H178.4a1,1,0,0,1,0-2h31.38a1,1,0,0,1,0,2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247,161.42h-32a1,1,0,0,1,0-2h32a1,1,0,0,1,0,2Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M193.36,167.94h-18a1,1,0,0,1,0-2h18a1,1,0,0,1,0,2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M247,167.94H199.49a1,1,0,0,1,0-2H247a1,1,0,0,1,0,2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M209.58,174.47H178.4a1,1,0,0,1,0-2h31.18a1,1,0,0,1,0,2Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M234.11,174.47H213.93a1,1,0,0,1,0-2h20.18a1,1,0,0,1,0,2Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.29,181H178.4a1,1,0,1,1,0-2h35.89a1,1,0,0,1,0,2Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 265.79,
    cy: 112.18,
    r: 1.71,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.78,
    cy: 112.18,
    r: 1.71,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.78,
    cy: 112.18,
    r: 1.71,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M157.38,128.78h0a1,1,0,0,1,0-2,1,1,0,0,1,1,1A1,1,0,0,1,157.38,128.78Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M157.38,135.31h0a1,1,0,1,1,0-2,1,1,0,0,1,1,1A1,1,0,0,1,157.38,135.31Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.38,141.83h0a1,1,0,0,1,0-2,1,1,0,0,1,1,1A1,1,0,0,1,157.38,141.83Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M157.38,148.36h0a1,1,0,0,1,0-2,1,1,0,0,1,1,1A1,1,0,0,1,157.38,148.36Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M157.38,154.89h0a1,1,0,0,1,0-2,1,1,0,0,1,1,1A1,1,0,0,1,157.38,154.89Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M157.38,161.42h0a1,1,0,0,1,0-2,1,1,0,0,1,1,1A1,1,0,0,1,157.38,161.42Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M157.38,167.94h0a1,1,0,1,1,0-2,1,1,0,0,1,1,1A1,1,0,0,1,157.38,167.94Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M157.38,174.47h0a1,1,0,0,1,0-2,1,1,0,0,1,1,1A1,1,0,0,1,157.38,174.47Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M157.38,181h0a1,1,0,0,1,0-2,1,1,0,0,1,1,1A1,1,0,0,1,157.38,181Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 221.49,
    y: 180.34,
    width: 160.53,
    height: 102.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.49,
    y: 180.34,
    width: 160.53,
    height: 102.79,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.49,
    y: 180.34,
    width: 25.04,
    height: 102.79,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.49,
    y: 180.34,
    width: 160.53,
    height: 8.29,
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.83,197.72l-2.66,1,2.66,1v1l-3.8-1.45v-1l3.8-1.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.7,194.76h1.11l-2.64,7.53h-1.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.76,198.17v1l-3.8,1.45v-1l2.66-1-2.66-1v-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M240.2,209.15H229.32a1,1,0,0,1,0-2H240.2a1,1,0,0,1,0,2Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M240.2,215.67H229.32a1,1,0,0,1,0-2H240.2a1,1,0,0,1,0,2Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M240.2,222.2H229.32a1,1,0,0,1,0-2H240.2a1,1,0,0,1,0,2Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M240.2,228.73H229.32a1,1,0,0,1,0-2H240.2a1,1,0,0,1,0,2Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M240.2,235.26H229.32a1,1,0,0,1,0-2H240.2a1,1,0,0,1,0,2Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M240.2,241.78H229.32a1,1,0,0,1,0-2H240.2a1,1,0,0,1,0,2Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M240.2,248.31H229.32a1,1,0,0,1,0-2H240.2a1,1,0,0,1,0,2Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M240.2,254.84H229.32a1,1,0,0,1,0-2H240.2a1,1,0,0,1,0,2Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M240.2,261.37H229.32a1,1,0,0,1,0-2H240.2a1,1,0,0,1,0,2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.65,209.15H249.34a1,1,0,0,1,0-2h22.31a1,1,0,0,1,0,2Z",
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.74,209.15H277.59a1,1,0,0,1,0-2h58.15a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.28,209.15H345.43a1,1,0,0,1,0-2h16.85a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.62,215.67H252.34a1,1,0,0,1,0-2h58.28a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.28,215.67H316a1,1,0,0,1,0-2h54.32a1,1,0,0,1,0,2Z",
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.88,222.2H252.34a1,1,0,1,1,0-2h34.54a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,222.2H294a1,1,0,0,1,0-2h34a1,1,0,0,1,0,2Z",
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.28,222.2H333.56a1,1,0,0,1,0-2h36.72a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.08,228.73H269.35a1,1,0,0,1,0-2h20.73a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.44,228.73H296.81a1,1,0,0,1,0-2h22.63a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.28,228.73h-36.7a1,1,0,0,1,0-2h36.7a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.23,235.26H252.34a1,1,0,0,1,0-2h27.89a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M283.72,241.78H252.34a1,1,0,0,1,0-2h31.38a1,1,0,0,1,0,2Z",
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.14,241.78H288.86a1,1,0,0,1,0-2h47.28a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.28,241.78H341.87a1,1,0,0,1,0-2h28.41a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.31,248.31h-18a1,1,0,0,1,0-2h18a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.9,248.31H286.44a1,1,0,0,1,0-2H320.9a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361.28,248.31H327.63a1,1,0,0,1,0-2h33.65a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.53,254.84H272.35a1,1,0,0,1,0-2h21.18a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.05,254.84H297.88a1,1,0,0,1,0-2h20.17a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361.28,254.84h-36.9a1,1,0,0,1,0-2h36.9a1,1,0,0,1,0,2Z",
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.24,261.37H272.35a1,1,0,0,1,0-2h25.89a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375,184.55a1.72,1.72,0,1,0,1.71-1.72A1.71,1.71,0,0,0,375,184.55Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.75,
    cy: 184.55,
    r: 1.71,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.74,
    cy: 184.55,
    r: 1.71,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.26,186.42H84.54a8.84,8.84,0,0,0-8.85,8.84v25a8.84,8.84,0,0,0,8.84,8.85H104.9l6,7.89v-7.89h2.35a8.85,8.85,0,0,0,8.85-8.85v-25A8.84,8.84,0,0,0,113.26,186.42Z",
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.26,186.42H84.54a8.84,8.84,0,0,0-8.85,8.84v25a8.84,8.84,0,0,0,8.84,8.85H104.9l6,7.89v-7.89h2.35a8.85,8.85,0,0,0,8.85-8.85v-25A8.84,8.84,0,0,0,113.26,186.42Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4,214a1.33,1.33,0,0,1-1-.46L90.81,207a1.31,1.31,0,1,1,2-1.7l4.59,5.42,7.59-8.94a1.31,1.31,0,0,1,2,1.69L98.4,213.56A1.31,1.31,0,0,1,97.4,214Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.9,
    cy: 207.65,
    r: 14.26,
    transform: "translate(-117.87 130.75) rotate(-45)",
    style: {
      fill: "#00afef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.72,363.48l21.47-1.05L224.1,381.1s-14.9,2.84-21.55-7.76Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.03 368.94 235.14 382.48 224.1 381.1 226.19 362.43 240.03 368.94",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.11,393.78a87.77,87.77,0,0,0,22.08-16.39l-1.47-13.91c-20.29,3-32,7.29-32,7.29s7.52-26.95.64-36.77l-18.89,3.42s-20.07,41.72-6.57,56.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.08,393.78a88,88,0,0,0,22.1-16.38l-1.46-13.93c-19.64,2.88-31.25,7-32,7.27.25-1,7.36-27.11.62-36.75l-18.89,3.42a146.63,146.63,0,0,0-9.21,26.06c-2.7,11.39-3.49,23.66,2.65,30.31Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.55,393.78c6.67-42.26.76-53,.76-53l-24,22.67c-2.7,11.39-3.49,23.66,2.65,30.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.38,393.78c4.5-21.36,9.55-54.8,9-59.78-.8-7.24-40.18-38.26-74.36-15.68-7,4.61-10.57,54.34-11.79,75.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.38,393.78c4.5-21.36,9.55-54.81,9-59.79-.8-7.23-40.19-38.25-74.37-15.66-2.53,1.69-4.61,9.32-6.33,19.4-2.28,13.72-3.86,31.94-4.8,45.68-.26,3.89-.48,7.41-.65,10.37Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.51,226.55c-11.85-4.79-39.79,12.4-42.24,43.05s13.09,22.16,13.09,22.16,2.77,11.69,14.09,8.08c0,0,9.35,10.59,18.05,6.28,0,0,10.83,11.28,16.64,5.33,0,0,6.32,7.21,12.09,1.75s22.26-61.2-3.61-74.09S147.51,226.55,147.51,226.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.53,352l-1.14-.1c1.32-14.76-1.93-21.29-2-21.35l1-.53C145.58,330.25,148.88,336.82,147.53,352Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.89,352.13c-7.85-18.49,1-22.8,1.36-23l.47,1-.24-.52.24.52c-.08,0-8.16,4.09-.78,21.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.22,333.54s-15.15-12-38.67-18.76L99,318.32s-12.66-15.67,8.44-20.8,49.8,9,57,21.1-12.52,16-12.52,16S150.11,332.16,145.22,333.54Z",
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.22,333.54s-15.15-12-38.67-18.76L99,318.32s-12.66-15.67,8.44-20.8,49.8,9,57,21.1-12.52,16-12.52,16S150.11,332.16,145.22,333.54Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36,351.91a1,1,0,1,1-1-1A1,1,0,0,1,154.36,351.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.87,351.91a1,1,0,1,1-1-1A1,1,0,0,1,147.87,351.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.17,277c-.92,10.73-4.21,29.83-12.94,34,0,0,9.76,2,25,21.31,8.67-6.08,5.39-10.23,5.39-10.23-10.14-6.65-7.51-14.85-3.41-22Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,286.41l8.31,13.7a31.85,31.85,0,0,0-2.51,5.2c-4-2.14-8.38-8.92-7.55-13.56A15.76,15.76,0,0,1,142.88,286.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,254.31c-2.79,16.86-4.33,23.92,1.92,34.77,9.39,16.33,30.2,17.1,37.85,1.66,6.88-13.9,10.29-39.14-4.07-50.28C157.53,229.48,138.77,237.44,136,254.31Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.53,231.07c10.93,6.06,21.34,25,5.79,20.27-2.35,4.55-10.72.38-15.59-5.08-.82,3.79-9.78,7.59-16.38,1.72,3.19,4.6-2.24,16.21-7.89,14.21s-18.33-4.63-7.1-22.53S158.86,224.58,170.53,231.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.55,270.22s1,6.69,2.9,10.32c-2.13,1.23-5-.41-5-.41Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.65,283.13a13,13,0,0,0,2.21.84.38.38,0,0,0,.48-.3.43.43,0,0,0-.31-.52,11.94,11.94,0,0,1-7.76-6.81.41.41,0,0,0-.52-.28.42.42,0,0,0-.23.54A12.55,12.55,0,0,0,155.65,283.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.49,266.43a13.71,13.71,0,0,0,6.38,8.31c4.07,2.23,7-1.59,6.7-6.34-.31-4.29-2.81-10.61-7.27-10.86S126.28,262,127.49,266.43Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5,254.77a.76.76,0,0,0,.64,0,6.19,6.19,0,0,1,5.82-.1.76.76,0,0,0,1.09-.3.91.91,0,0,0-.33-1.17,7.66,7.66,0,0,0-7.36,0,.86.86,0,0,0-.32,1.14A.91.91,0,0,0,154.5,254.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.37,261.35a.74.74,0,0,0,.6.06.82.82,0,0,0,.51-1.06,8.77,8.77,0,0,0-5.21-5.78.76.76,0,0,0-1,.57.9.9,0,0,0,.58,1.06,7,7,0,0,1,4.08,4.63A.88.88,0,0,0,181.37,261.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.88,265.8c-.49,1.34-1.61,2.15-2.5,1.82s-1.21-1.67-.72-3,1.61-2.15,2.49-1.82S160.36,264.47,159.88,265.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.76,262.73l3.32-.07S159.74,264.56,158.76,262.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.67,271.13c-.49,1.33-1.61,2.14-2.49,1.82s-1.22-1.68-.73-3,1.61-2.14,2.5-1.82S177.16,269.79,176.67,271.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.56,268.05l3.31-.07S176.53,269.89,175.56,268.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.3,275.25a7.35,7.35,0,0,1-3-.63,7.59,7.59,0,0,1-4.14-4.84,10.13,10.13,0,0,1,5.29-11.85,7.46,7.46,0,0,1,10.53,4.7,9.85,9.85,0,0,1-.51,6.88h0a9.84,9.84,0,0,1-4.79,5A8,8,0,0,1,158.3,275.25Zm1.57-16.95A7,7,0,0,0,157,259a9,9,0,0,0-4.68,10.48,6.3,6.3,0,0,0,8.95,4,8.71,8.71,0,0,0,4.23-4.39l.52.23-.52-.23a8.72,8.72,0,0,0,.45-6.09,6.44,6.44,0,0,0-3.52-4.13A6,6,0,0,0,159.87,258.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.94,280.35a7.16,7.16,0,0,1-3-.63,7.63,7.63,0,0,1-4.15-4.84,10.15,10.15,0,0,1,5.3-11.85,7.44,7.44,0,0,1,10.52,4.7,9.79,9.79,0,0,1-.5,6.88h0A9.3,9.3,0,0,1,174.94,280.35Zm1.59-17a7,7,0,0,0-2.92.66,8.77,8.77,0,0,0-4.23,4.4,8.63,8.63,0,0,0-.45,6.08,6.46,6.46,0,0,0,3.52,4.14c3.5,1.57,7.84-.47,9.66-4.53h0a8.77,8.77,0,0,0,.45-6.09,6.47,6.47,0,0,0-3.52-4.13A6.25,6.25,0,0,0,176.53,263.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.8,269.92a.51.51,0,0,0-.29-.32,2.08,2.08,0,0,0-1.29.19l-.5-1a3.07,3.07,0,0,1,2.2-.23,1.64,1.64,0,0,1,1,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.64,
    y: 254.56,
    width: 1.14,
    height: 14.1,
    transform: "matrix(0.3, -0.96, 0.96, 0.3, -147.66, 322.8)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.28,364.46s-26.31,20.16-49.4,19c.94-13.74,2.52-32,4.8-45.68,2.36-2.6,3.91-4.18,3.91-4.18l14,10.47-3.41,4.28s21.19-1.08,28.57,0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,348.3,161.06,344l.75,18.78s-14.29,5.06-22.47-4.41Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.72 348.36 172.94 362.48 161.81 362.79 161.06 344.01 175.72 348.36",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140 348.3 141.03 362.79 135.79 365.14 133.55 348.3 140 348.3",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140 348.3 141.03 362.79 135.79 365.14 133.55 348.3 140 348.3",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55,314.78a24.36,24.36,0,0,0-14.45,8.36c-6.35,7.46-28.73,29.62-23.76,47.71s52.83,4.63,67.45-5.71l-2.24-16.84-33.15,2.43L110.62,344C117.63,324.5,106.55,314.78,106.55,314.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55,314.78a24.36,24.36,0,0,0-14.45,8.36c-6.35,7.46-28.73,29.62-23.76,47.71s52.83,4.63,67.45-5.71l-2.24-16.84-33.15,2.43L110.62,344C117.63,324.5,106.55,314.78,106.55,314.78Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.56 363.8 208.59 362.79 208.59 378.95 203.81 379.73 202.56 363.8",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.56 363.8 208.59 362.79 208.59 378.95 203.81 379.73 202.56 363.8",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.37,378.79a19.44,19.44,0,0,1,.13-2.65l.18-1.33-1.29.76-.77.46a6.16,6.16,0,0,1-.78.29,2.32,2.32,0,0,1-1.4,0,2.57,2.57,0,0,1-1.12-.81,4.69,4.69,0,0,1-.79-1.36L183.4,371l-.8,3.34c-.08.33-.13.67-.19,1s-.2.62-.29.93a3,3,0,0,1-.93,1.27,2,2,0,0,1-1.51.13,6.23,6.23,0,0,1-1.78-.78l-1.74-1.09.7,1.77a14.88,14.88,0,0,1,.72,2.32,7.05,7.05,0,0,1,.16,1.2,1.9,1.9,0,0,1-.26,1.18,1.92,1.92,0,0,0,.68-1.12,5.38,5.38,0,0,0,.18-1.32,9.13,9.13,0,0,0,0-1.05,8.34,8.34,0,0,0,.9.44,3.55,3.55,0,0,0,2.85-.07,4.28,4.28,0,0,0,1.87-2.12l0-.13a3.81,3.81,0,0,0,4.45.95,6.86,6.86,0,0,0,.85-.46s0,.07,0,.11a13.37,13.37,0,0,0,.29,1.4,7.3,7.3,0,0,0,.5,1.35,3.11,3.11,0,0,0,.87,1.12,3.48,3.48,0,0,1-.43-1.27A9.82,9.82,0,0,1,190.37,378.79Z",
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.14,356.23a5.72,5.72,0,0,1-2.31-.25,8.38,8.38,0,0,1-2.17-1,6.5,6.5,0,0,1-1.61-1.73,9,9,0,0,1-1.07-2.15l-.66-2-1.12,1.77a9.62,9.62,0,0,1-1.72,2,3.22,3.22,0,0,1-2,.92l-.24,0-.3-.06c-.21,0-.41-.1-.62-.15a7.48,7.48,0,0,1-1.21-.52,10.37,10.37,0,0,1-2.15-1.6l-1.74-1.67.36,2.29a18.36,18.36,0,0,1,.23,3.7,5.14,5.14,0,0,1-.35,1.7,1.13,1.13,0,0,1-1.22.7l-.45,0,.14.37q.44,1.13.9,2.25c-.09-.67-.2-1.34-.32-2l.19,0a3.17,3.17,0,0,0,.59-.1,4.66,4.66,0,0,0,.53-.32c.13-.14.27-.29.39-.44a5.27,5.27,0,0,0,.75-2,12.73,12.73,0,0,0,.22-2v0a11.41,11.41,0,0,0,1,.74,8.86,8.86,0,0,0,1.48.73,5.18,5.18,0,0,0,1.73.39,5.07,5.07,0,0,0,3.34-1.32,9.28,9.28,0,0,0,1.09-1.08,11.42,11.42,0,0,0,.64,1,8.28,8.28,0,0,0,2.2,2.09,8.58,8.58,0,0,0,2.77,1.08,8.08,8.08,0,0,0,1.91.14c-.08.2-.17.4-.24.61a13.59,13.59,0,0,0-.41,1.76,6.88,6.88,0,0,0-.08,1.81,3.58,3.58,0,0,0,.53,1.7,3.74,3.74,0,0,1-.13-1.69,8.6,8.6,0,0,1,.39-1.65,17,17,0,0,1,1.45-3l.63-1.07Z",
    style: {
      fill: "#00afef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5,400.08H426.2a4.44,4.44,0,0,1,4.44,4.44v10.8a0,0,0,0,1,0,0H71.06a0,0,0,0,1,0,0v-10.8A4.44,4.44,0,0,1,75.5,400.08Z",
    transform: "translate(501.7 815.41) rotate(180)",
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.06,
    y: 400.08,
    width: 359.59,
    height: 7.62,
    transform: "translate(501.7 807.78) rotate(180)",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.52,402.07H438.18a4.3,4.3,0,0,0,4.3-4.29h0a4.3,4.3,0,0,0-4.3-4.3H63.52a4.3,4.3,0,0,0-4.3,4.3h0A4.3,4.3,0,0,0,63.52,402.07Z",
    style: {
      fill: "#00afef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.79,341l-10.94,49.62a3.73,3.73,0,0,1-3.55,2.82H338.54a2.41,2.41,0,0,1-2.24-3.12l10.92-49.24a3.42,3.42,0,0,1,3.55-2.43h59.76C412.13,338.69,413.14,339.42,412.79,341Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.79,341l-10.94,49.62a3.73,3.73,0,0,1-3.55,2.82H340.57a2.41,2.41,0,0,1-2.25-3.12l10.94-49.24a3.39,3.39,0,0,1,3.55-2.43h57.72C412.13,338.69,413.14,339.42,412.79,341Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.26,391.91l10.88-49.36c.36-1.62-.65-2.35-2.26-2.35H354.16a3.41,3.41,0,0,0-3.55,2.43l-11.05,49.93Z",
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.14,342.54l-5.74,26.08-5.15,23.29-34.1.35-29.58.29,11-49.92a3.39,3.39,0,0,1,3.54-2.43H411.9C413.5,340.2,414.5,340.94,414.14,342.54Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.4,368.62l-5.15,23.29-34.1.35H340.83l4.63-21.3a3,3,0,0,1,2.9-2.34Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.38,371.86a3.39,3.39,0,0,0-3.55-2.42H348.11c-1.6,0-2.61.72-2.26,2.34l4.38,19.86h-9.75a.92.92,0,1,0,0,1.84h71.1a2.09,2.09,0,0,0,2-2.55Z",
    style: {
      fill: "#00afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.38,371.86a3.39,3.39,0,0,0-3.55-2.42H348.11c-1.6,0-2.61.72-2.26,2.34l4.38,19.86h-9.75a.92.92,0,1,0,0,1.84h71.1a2.09,2.09,0,0,0,2-2.55Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "338.75 383.91 335.4 383.91 334.98 385.72 338.24 385.72 338.75 383.91"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M317.58,393.71h-9.65a.56.56,0,0,1-.57-.57.57.57,0,0,1,.57-.57h9.65a10.55,10.55,0,0,0,8.25-3.95,11.68,11.68,0,0,1,9.15-4.38h1.7a.58.58,0,0,1,.57.57.57.57,0,0,1-.57.57H335a10.55,10.55,0,0,0-8.25,3.95A11.69,11.69,0,0,1,317.58,393.71Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.78,386.65v4.17c0,1.88,2.27,2.66,4.15,2.66H307.51c1.86,0,4.07-.78,4.07-2.66v-4.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.78,386.65v4.17c0,1.88,2.27,2.66,4.15,2.66H307.51c1.86,0,4.07-.78,4.07-2.66v-4.17Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.72,386.65v4.17c0,1.88,2.23,2.66,4.11,2.66h96.68c1.86,0,4.07-.78,4.07-2.66v-4.17Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.11,307.33l-17.45,79.15A5.94,5.94,0,0,1,313,391H217.67c-2.53,0-4.17-2.37-3.58-5l17.43-78.55c.59-2.58,3.11-3.87,5.67-3.87h95.32C335.07,303.59,336.68,304.75,336.11,307.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.11,307.33l-17.45,79.15A5.94,5.94,0,0,1,313,391H220.91c-2.56,0-4.17-2.37-3.6-5l17.45-78.55c.57-2.58,3.11-3.87,5.67-3.87h92.08C335.07,303.59,336.68,304.75,336.11,307.33Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.11,347.56v0c0,6.78-7.26,12.29-12.59,12.29s-8.48-5.51-7-12.29,6.81-12.05,12-12.26c-1.52,6.78,1.73,12.26,7,12.26A3.12,3.12,0,0,0,289.11,347.56Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoding);
export default __webpack_public_path__ + "static/media/coding.304f712afe2df702ba7961488b922abb.svg";
export { ForwardRef as ReactComponent };